import { Injectable } from "@angular/core";
import { SwalToastService } from "./swal.service";
import { TranslateService } from "@ngx-translate/core";
import { EpisodeOfCareService } from './episodeOfCare.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PatientService } from "./patient.service";
import { BehaviorSubject, Observable } from "rxjs";
import { IDietaryHabitsDetailed } from "../interfaces/SocialHistory/DietaryHabits/IDietaryHabitsDetailed";
import { IGenericServiceResponse, IServiceResponse } from "../interfaces/IServiceResponse";
import { environment } from "src/environments/environment";
import { IDietaryHabitsDropdown } from "../interfaces/SocialHistory/DietaryHabits/IDietaryHabitsDropdown";
import { IAddDietaryHabits } from "../interfaces/SocialHistory/DietaryHabits/IAddDietaryHabits";
@Injectable({
    providedIn: 'root',
})
export class DietaryHabitsService {
    public dietaryHabitsModalSub = new BehaviorSubject<boolean>(false);
    public dietaryHabitsEditSub = new BehaviorSubject<IDietaryHabitsDetailed | null>(null);
    public dietaryHabitsDataSub = new BehaviorSubject<IDietaryHabitsDetailed[]>([]);
    public dietaryHabitsLoadingSub = new BehaviorSubject<boolean>(false);
    public dietaryHabitsLoadingSub$ = this.dietaryHabitsLoadingSub.asObservable();


    constructor(
        private readonly _http: HttpClient,
        private readonly eocService: EpisodeOfCareService,
        private readonly patientService: PatientService,
        private readonly translate: TranslateService,
        private readonly swalToastService: SwalToastService
    ) { }

    getData() {
        this.dietaryHabitsLoadingSub.next(true);
        this.getDietaryHabits(
            this.patientService.patientIDsignal(),
            this.eocService.currentVisitId()
        ).subscribe({
            next: (response) => {
                this.dietaryHabitsDataSub.next(response?.data!);
                this.dietaryHabitsLoadingSub.next(false);
            },
            error: (err) => {
                this.swalToastService.toastError('Unable to retrieve dietary habits');
                console.error('Error fetching dietary habits:', err);
            },
        });
    }


    getDietaryHabits(patientId: string, visitId?: string): Observable<IGenericServiceResponse<IDietaryHabitsDetailed[]>> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        if (visitId) {
            return this._http.get<IGenericServiceResponse<IDietaryHabitsDetailed[]>>(`${environment.BACKEND_URL}DietaryHabits/${patientId}?visitId=${visitId}`, {
                headers: headers,
            });

        } else {
            return this._http.get<IGenericServiceResponse<IDietaryHabitsDetailed[]>>(`${environment.BACKEND_URL}DietaryHabits/${patientId}`, {
                headers: headers,
            });

        }
    }

    getDietaryHabitsDropdown(): Observable<
        IGenericServiceResponse<IDietaryHabitsDropdown>
    > {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        return this._http.get<IGenericServiceResponse<IDietaryHabitsDropdown>>(
            `${environment.BACKEND_URL}DietaryHabits/DropdownData`,
            {
                headers: headers,
            }
        );
    }



    addDietaryHabits(dietaryHabitsObj: IAddDietaryHabits) {
        dietaryHabitsObj.visitId = this.eocService.currentVisitId();
        dietaryHabitsObj.patientId = this.patientService.patientIDsignal();

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this._http.post(
            `${environment.BACKEND_URL}DietaryHabits`,
            dietaryHabitsObj,
            {
                headers: headers,
            }
        );
    }

    updateDietaryHabits(dietaryHabitsObj: IAddDietaryHabits, dietaryHabitsId: number) {
        dietaryHabitsObj.visitId = this.eocService.currentVisitId();
        dietaryHabitsObj.patientId = this.patientService.patientIDsignal();

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this._http.put(
            `${environment.BACKEND_URL}DietaryHabits/${dietaryHabitsId}`,
            dietaryHabitsObj,
            {
                headers: headers,
            }
        );
    }

    deleteDietaryHabits(dietaryHabitsId: number): Observable<IServiceResponse> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        return this._http.delete<IServiceResponse>(
            `${environment.BACKEND_URL}DietaryHabits/${dietaryHabitsId}`,
            {
                headers: headers,
            }
        );
    }

}